import styled from 'styled-components'

const Breadcrumb = styled.div`
  display: flex;
  font-size: 10px;
  padding: 10px 0 4px 0;
  color: #454545;
  align-items: center;
  & a{
    text-decoration: none;
    color: #020266;
  }
  & svg{
    margin: 0 3px;
  }
`

const Button = styled.button`
display: flex;
align-items: center;
justify-content: center;
padding:3px 6px;
 border:0.1em solid #020266;
 margin:0 0.3em 0.3em 0;
 border-radius:2px;
 box-sizing: border-box;
 text-decoration:none;
 font-family:'Roboto',sans-serif;
 font-weight:300;
 color:#020266;
 text-align:center;
 background:transparent;
 transition: all 0.2s;
 outline: none;
}
& svg{
  margin-right:4px;
}
&:hover{
 color:#000000;
 background-color:#FFFFFF;
}
@media all and (max-width:30em){
  margin:0.4em auto;
}
`
const Note = styled.div`
  position: relative;
  font-size: 12px;
  color: #454545;
  padding-bottom: 6px;
  padding-top: 6px;
  & > span {
    font-weight: 600;
  }
`;

const TableWrapper = styled.section`
  padding: 5px 0;
  & > div {
    padding: 5px;
    background: #3a3a3a;
    color: #fff;
    font-size: 14px;
    text-align: center;
    & span {
      font-size: 12px;
    }
  }
  & table {
    border-collapse: collapse;
    width: 100%;
    & thead tr {
      background: #c4ffcd;
    }
    & td {
      padding: 3px;
      font-size: 12px;
      text-align: center;
    }
  }
`;

const Input = styled.input`
  border: 1px solid hsl(0,0%,80%);
  border-radius: 4px;
  width: 100%;
  padding: 10px;
  width: 100%;
`
const TextArea = styled.textarea`
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 4px;
  width: 100%;
  min-height:100px;
`;

export{Breadcrumb,Note,Button,TableWrapper, Input,TextArea}